// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Du8t","amount":"Amount_amount__3E5ph","tip":"Amount_tip___V7Mx","tipHeader":"Amount_tipHeader__HJHTk","tipsWrap":"Amount_tipsWrap__1mQ3f"};